
import styled from 'styled-components';
import { Option } from '.';
import Select from 'react-select';

export const DivMapping = styled.div`
	display:flex;
	align-items:center;
	position: relative;
`;

export const SVGMap = styled.svg`
	position: relative;
	margin-right:7px;
	color:#a1a1a1;
	margin-left: 2px;
`;

export const SelectList = styled.select`
	font-size: 0.938rem;
	background-color: var(--defaultBgColor);
	color: var(--textTitleColor);
	font-family: Inter;
	font-weight: 500;
	background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #FFF;
	border: 1px solid var(--controlBorderColor);
	box-shadow:none;
	border-radius:40px;
	height: 40px;
	appearance: none;
		&:focus-visible {
			outline: 1px solid #ccc;
		}
	@media (max-width: 1325px) {
		padding: 6px 34px 6px 36px;
		font-size: 0.856rem;
	}
	@media (max-width: 936px){
		height:34px;
		
	}
	
`;

export const SVGDown = styled.svg`
	position: absolute;
	color:#a1a1a1;
	right: 16px;
	pointer-events:none;
`;
export const OptionGroup = styled.optgroup`
	font-size: 0.938rem;
	color: #28373e;
	font-family: 'Inter';
	font-weight: 500;
`;

export const StyledSelect = styled(Select<Option>)`

&.imagary-provider-select{
	.cus-select__control{
		border: 1px solid var(--controlBorderColor);
		box-shadow:none;
		border-radius:40px;
		flex-wrap: nowrap;
		font-size: 0.925rem;
		background-color: var(--selectDropdownBgColor);
	}
	.cus-select__value-container{
		padding: 7px 4px 7px 8px !important;	
		min-width:140px;
		span{
			font-size: 0.9rem;
		}
	}
	.cus-select__indicator-separator{
		margin-top: 0px !important;
		margin-bottom: 0px !important;
		background-color: transparent;
	}
	.cus-select__dropdown-indicator{
    color: rgb(176, 178, 180);
		padding: 6px 12px 6px 2px;

		svg{
			height: 19px;
			width: 19px;
		}
  }
	
	.cus-select__single-value{
	  color: var(--textColor);
		display: flex;
    align-items: center;
		font-size: 0.925rem;
	}
	&.cus-select--is-disabled{
		cursor: not-allowed !important;
		opacity: .6 !important;
		pointer-events: auto !important;

		* {
			cursor: not-allowed !important;
		}
	}
}
	.cus-select__menu{
		margin:0;
		z-index:10;
		background: var(--selectDropdownBgColor);
	}
  .cus-select__menu-list{
		padding: 0px;
		border-radius: 4px;
	}
	.cus-select__group-heading{
		line-height:1.4;
		padding: 4px 11px;
		text-align: center;
	}
		.cus-select__group{
			padding-top:5px;
			padding-bottom:0px;
		}
	width: 100%;
	font-size: .925rem;
	margin-top: 0px;
	color: var(--textColor);

`;

export const IconPremium = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: flex-start;
		background-color: #FFF0CF;
		color: #2D230D;
		border: 1px solid #FEB517;
		border-radius: 15px;
		font-weight: 500;
		padding: 4px 7px;
		font-size: 9px;
		marginLeft: 2px;
		lineHeight: 1.4;
		// min-width: 83px;
		svg{
			position: relative;
    	top: -1px;
		}
`;